export default {
    STORE_LOCATION: "mate_set_locatioon",
  
  };